<script lang="ts">
  import type { IconType } from "$types/atoms";

  export let type: IconType | null = null;
  export let width = 16;
  export let height = 16;
  export let classes = "";
</script>

<svg class={classes} {width} {height}>
  <use xlink:href={`/svg/icons.svg#${type}`} />
</svg>
